import { render, staticRenderFns } from "./workfilesetting.vue?vue&type=template&id=61a6aeaf&scoped=true"
import script from "./workfilesetting.vue?vue&type=script&lang=js"
export * from "./workfilesetting.vue?vue&type=script&lang=js"
import style0 from "./workfilesetting.vue?vue&type=style&index=0&id=61a6aeaf&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6aeaf",
  null
  
)

export default component.exports